import React from 'react';
import {
    XAxis,
    YAxis,
    ResponsiveContainer,
    LineChart,
    Line,
    Legend,
    Tooltip,
    CartesianGrid,
  } from 'recharts';
import { Card, CardContent } from "../../../components/ui/card";
import constants from '../../../commonUtils/constants';


const UploadsOverTime = ({ data }) => {
    return (
        <>
            <Card className="shadow-md rounded-2xl col-span-1 md:col-span-1 lg:col-span-2">
                <CardContent>
                    <h2 className="text-lg font-bold mb-4">Uploads Over Time</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <LineChart data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis allowDecimals={false} />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="uploads" stroke={constants.dashboard.colors[4]} strokeWidth={2} />
                        </LineChart>
                    </ResponsiveContainer>
                </CardContent>
            </Card>
        </>
    );
};

export default UploadsOverTime;
